'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _Navbar = require('../Navbar/Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

var _NavbarNav = require('../NavbarNav/NavbarNav');

var _NavbarNav2 = _interopRequireDefault(_NavbarNav);

var _Icon = require('../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */
var CodeMirror = null;
if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
  CodeMirror = require('react-codemirror');
  require('codemirror/mode/javascript/javascript');
  require('codemirror/mode/markdown/markdown');
  require('codemirror/mode/jsx/jsx');
  require('codemirror/mode/css/css');
  require('codemirror/mode/sass/sass');
}
/* eslint-enable */

var Code = function (_React$Component) {
  _inherits(Code, _React$Component);

  function Code(props) {
    _classCallCheck(this, Code);

    var _this = _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).call(this, props));

    _this.state = {};
    _this.updateCode = _this.updateCode.bind(_this);
    _this.toggleReadOnly = _this.toggleReadOnly.bind(_this);
    _this.copyToClipboard = _this.copyToClipboard.bind(_this);
    _this.clearCode = _this.clearCode.bind(_this);
    _this.onUpdate = _this.onUpdate.bind(_this);
    return _this;
  }

  _createClass(Code, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          code = _props.code,
          readOnly = _props.readOnly,
          languageCode = _props.languageCode,
          lineNumbers = _props.lineNumbers,
          showheader = _props.showheader,
          showfooter = _props.showfooter,
          bgColorDark = _props.bgColorDark;

      this.setState({
        scode: code,
        sreadOnly: readOnly,
        slanguageCode: languageCode,
        slineNumbers: lineNumbers,
        sshowheader: showheader,
        sshowfooter: showfooter,
        sbgColorDark: bgColorDark
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      /* eslint-disable react/no-string-refs */
      if (this.refs.editor) this.refs.editor.getCodeMirror().refresh();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.onUpdate(prevProps);
    }
  }, {
    key: 'onUpdate',
    value: function onUpdate(prevProps) {
      var _this2 = this;

      var _props2 = this.props,
          readOnly = _props2.readOnly,
          lineNumbers = _props2.lineNumbers,
          bgColorDark = _props2.bgColorDark,
          languageCode = _props2.languageCode,
          code = _props2.code,
          showheader = _props2.showheader,
          showfooter = _props2.showfooter;


      if (prevProps.readOnly !== readOnly) {
        this.setState({
          sreadOnly: readOnly
        });
      }
      if (prevProps.lineNumbers !== lineNumbers) {
        this.setState({
          slineNumbers: lineNumbers
        });
      }
      if (prevProps.bgColorDark !== bgColorDark) {
        this.setState({ sbgColorDark: bgColorDark });
      }
      if (prevProps.languageCode !== languageCode) {
        this.setState({ slanguageCode: languageCode });
      }
      if (prevProps.code !== code) {
        this.setState({ scode: code }, function () {
          _this2.refs.editor.getCodeMirror().setValue(code);
        });
      }

      if (prevProps.showheader !== showheader) {
        this.setState({ sshowheader: showheader });
      }
      if (prevProps.showfooter !== showfooter) {
        this.setState({ sshowfooter: showfooter });
      }
    }
  }, {
    key: 'updateCode',
    value: function updateCode(newCode) {
      var _this3 = this;

      this.setState({ scode: newCode, scopied: false }, function () {
        var updateCode = _this3.props.updateCode;

        updateCode(newCode);
      });
    }
  }, {
    key: 'clearCode',
    value: function clearCode() {
      var _this4 = this;

      this.setState({ scode: '', scopied: false }, function () {
        var updateCode = _this4.props.updateCode;

        updateCode('');
        _this4.refs.editor.getCodeMirror().setValue('');
      });
    }
  }, {
    key: 'toggleReadOnly',
    value: function toggleReadOnly() {
      var _this5 = this;

      var sreadOnly = this.state.sreadOnly;

      this.setState({
        sreadOnly: !sreadOnly
      }, function () {
        return _this5.refs.editor.focus();
      });
    }
  }, {
    key: 'copyToClipboard',
    value: function copyToClipboard() {
      this.setState({ scopied: true });
    }
  }, {
    key: 'render',
    value: function render() {
      /* eslint no-script-url: "error" */
      var _state = this.state,
          sreadOnly = _state.sreadOnly,
          slanguageCode = _state.slanguageCode,
          slineNumbers = _state.slineNumbers,
          sshowheader = _state.sshowheader,
          sbgColorDark = _state.sbgColorDark,
          scode = _state.scode,
          scopied = _state.scopied,
          sshowfooter = _state.sshowfooter;
      var theme = this.props.theme;

      var options = {
        lineNumbers: slineNumbers,
        readOnly: sreadOnly,
        mode: slanguageCode,
        theme: theme
      };
      return _react2.default.createElement(
        'div',
        null,
        sshowheader && _react2.default.createElement(
          _Navbar2.default,
          { className: '' + (sbgColorDark ? 'CodeMirror__header-dark' : 'CodeMirror__header') },
          _react2.default.createElement(
            _NavbarNav2.default,
            { alignItems: 'right' },
            _react2.default.createElement(
              _reactCopyToClipboard.CopyToClipboard,
              { text: scode, onCopy: this.copyToClipboard },
              _react2.default.createElement(
                _Button2.default,
                {
                  onClick: this.copyToClipboard,
                  className: 'btn ' + (scopied ? 'disabled' : '') + ' CodeMirror_btn',
                  tooltip: 'Copy'
                },
                _react2.default.createElement(_Icon2.default, { className: 'CodeMirror__header_copybtn', icon: 'fa fa-clone', role: 'link' })
              )
            ),
            _react2.default.createElement(
              _Button2.default,
              {
                onClick: this.clearCode,
                className: 'btn ' + (sreadOnly ? 'disabled' : '') + ' CodeMirror_btn',
                tooltip: 'Clear'
              },
              _react2.default.createElement(_Icon2.default, { className: 'CodeMirror__header_deletebtn', icon: 'fa fa-trash-o' })
            )
          )
        ),
        CodeMirror && _react2.default.createElement(CodeMirror, {
          ref: 'editor',
          className: sbgColorDark ? 'CodeMirror__bgColor-dark' : '',
          value: scode,
          onChange: this.updateCode,
          options: options,
          autoFocus: true
        }),
        sshowfooter && _react2.default.createElement(_Navbar2.default, { className: sbgColorDark ? 'CodeMirror__header-dark' : 'CodeMirror__header' })
      );
    }
  }]);

  return Code;
}(_react2.default.Component);

Code.propTypes = {
  bgColorDark: _propTypes2.default.bool,
  readOnly: _propTypes2.default.bool,
  lineNumbers: _propTypes2.default.bool,
  showheader: _propTypes2.default.bool,
  showfooter: _propTypes2.default.bool,
  code: _propTypes2.default.string,
  languageCode: _propTypes2.default.string,
  theme: _propTypes2.default.string,
  updateCode: _propTypes2.default.func
};

Code.defaultProps = {
  code: 'const component = {\n\tname: "react-code",\n\tauthor: "front10-devs",\n\trepo: "ht' + 'tps://gitlab.com/front10-devs/landing-page-book"\n};',
  bgColorDark: false,
  languageCode: 'javascript',
  theme: 'idea',
  readOnly: false,
  lineNumbers: true,
  showheader: true,
  showfooter: true,
  updateCode: function updateCode() {}
};

exports.default = Code;